module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/icon_title_4-075af886777be3c245f73febb27c6595.svg";